import type { Dispatch } from 'react';

import type { BuilderAction } from '../builderReducer';
import type { BuilderState } from '../types';
import { FormHeaderCard } from './FormHeaderCard';
import { SectionCard } from './SectionCard';

interface BuilderCanvasProps {
    activeQuestionId: string | null;
    dispatch: Dispatch<BuilderAction>;
    onAddQuestion: (sectionId: string) => void;
    onDeleteSection: (sectionId: string) => void;
    snapshot: BuilderState['snapshot'];
}

export function BuilderCanvas({
    activeQuestionId,
    dispatch,
    onAddQuestion,
    onDeleteSection,
    snapshot,
}: BuilderCanvasProps) {
    let questionNumberOffset = 0;

    return (
        <div className="mx-auto max-w-5xl space-y-5 pb-28 lg:pb-10">
            <FormHeaderCard dispatch={dispatch} snapshot={snapshot} />
            {snapshot.sections.map((section, sectionIndex) => {
                const currentOffset = questionNumberOffset;
                questionNumberOffset += section.questions.length;

                return (
                    <SectionCard
                        key={section.id}
                        activeQuestionId={activeQuestionId}
                        dispatch={dispatch}
                        onAddQuestion={onAddQuestion}
                        onDeleteSection={onDeleteSection}
                        questionNumberOffset={currentOffset}
                        section={section}
                        sectionIndex={sectionIndex}
                        totalSections={snapshot.sections.length}
                    />
                );
            })}
        </div>
    );
}
